import React, { useMemo } from 'react'

import { useRouter } from 'next/router'

import classnames from 'classnames'
import { Button } from 'ethos-design-system'
import { cmsModuleAnalytics } from 'lib/@getethos/analytics/analyticsEvents'

import styles from '../Trustworthy.module.scss'

interface DualCTASectionProps {
  isDualCtaTreatment1?: boolean
  isDualCtaTreatment2?: boolean
  isDualCtaTreatment3?: boolean
  isDualCtaTreatment4?: boolean
  brandColorsClassName?: string
  arrowIcon?: boolean
  ctaClick: () => void
  secondCtaClick?: () => void
  arrowForward: React.ReactNode
}

const DualCTASection: React.FC<DualCTASectionProps> = ({
  isDualCtaTreatment1 = false,
  isDualCtaTreatment2 = false,
  isDualCtaTreatment3 = false,
  isDualCtaTreatment4 = false,
  brandColorsClassName,
  arrowIcon,
  ctaClick,
  secondCtaClick,
  arrowForward,
}) => {
  const { push } = useRouter()

  const onTreatment4Click = () => {
    cmsModuleAnalytics.ctaClicked({
      properties: {
        module: 'Single CTA',
        ctaLabel: 'Get my price',
        clickthroughUrl: '/products/choose',
      },
    })

    push('/products/choose')
  }

  const lineHeight = useMemo(() => {
    if (isDualCtaTreatment2) {
      return '110%'
    }

    return '130%'
  }, [isDualCtaTreatment2])

  if (isDualCtaTreatment1 || isDualCtaTreatment2 || isDualCtaTreatment3) {
    return (
      <div
        className={classnames(styles.dualCtaContainer, {
          [styles.dualCtaTreatment2]: isDualCtaTreatment2,
        })}
      >
        <div className={classnames(styles.cta, brandColorsClassName)}>
          <Button.Unstyled
            fullWidth
            arrowIcon={!!arrowIcon}
            onClick={() => ctaClick()}
          >
            <div className={styles.ctaLabel}>
              <div>
                <p
                  className={`font-[Theinhardt] text-lg font-medium leading-[${lineHeight}%] tracking-[-0.18px] text-[#272727]`}
                >
                  Get life insurance prices
                </p>
                {isDualCtaTreatment2 && (
                  <p
                    className={`font-[Theinhardt] text-sm font-normal leading-[${lineHeight}%] tracking-[-0.5px] text-[#272727]`}
                  >
                    No medical exams or blood tests
                  </p>
                )}
              </div>
              {arrowForward}
            </div>
          </Button.Unstyled>
        </div>
        <div className={classnames(styles.cta, brandColorsClassName)}>
          <Button.Unstyled
            fullWidth
            arrowIcon={!!arrowIcon}
            onClick={() => secondCtaClick!()}
          >
            <div className={styles.ctaLabel}>
              <div>
                <p
                  className={`font-[Theinhardt] text-lg font-medium leading-[${lineHeight}%] tracking-[-0.18px] text-[#272727]`}
                >
                  Create a will & trust
                </p>
                {isDualCtaTreatment2 && (
                  <p
                    className={`font-[Theinhardt] text-sm font-normal leading-[${lineHeight}%] tracking-[-0.5px] text-[#272727]`}
                  >
                    No expensive attorneys or appointments
                  </p>
                )}
              </div>
              {arrowForward}
            </div>
          </Button.Unstyled>
        </div>
      </div>
    )
  }

  if (isDualCtaTreatment4) {
    return (
      <div
        className={classnames(
          styles.cta,
          brandColorsClassName,
          styles.dualCtaTreatment4
        )}
      >
        <Button.Unstyled
          fullWidth
          arrowIcon={!!arrowIcon}
          onClick={onTreatment4Click}
        >
          <p className="font-[Theinhardt] text-lg font-medium leading-[130%] tracking-[-0.18px] text-[#272727]">
            Get my price
          </p>
        </Button.Unstyled>
      </div>
    )
  }

  return null
}

export default DualCTASection
